import { combineReducers } from 'redux';

import data from './data/reducer';
import AddressBook from './scenes/AddressBook/reducer';

export default combineReducers({
  data,
  AddressBook,
});
